SupportFlashView = require('../views/flash_view')
SupportFinePrintView = require('../views/order_related/fine_print_view')
SupportCMSModel = require('../models/CMS')
SupportInbentaModel = require('../models/Inbenta')
SharedSpinnerView = require('../../../shared/frontend/views/spinner_view')

SupportUtilsHelper =
  delay: (ms, func) ->
    setTimeout(func, ms)

  flash: (type, content, sticky = false) ->
    view = new SupportFlashView
      type: type
      content: content
      sticky: sticky
    view.render()
    $('#flash_container').html(view.$el)

  highlight: ($element, callback, className = 'flash_highlight') ->
    $element.addClass(className)
    delay Groupon.Support.DELAY_TIMES.flash, ->
      $element.removeClass(className)
      callback() if callback

  highlightText: ($element, callback) ->
    $element.addClass('flash_text')
    delay Groupon.Support.DELAY_TIMES.flash, ->
      $element.removeClass('flash_text')
      callback() if callback

  openLocation: (url) ->
    window.open(url)

  isFileUploadSupported: ->
    window.FileReader?

  showLoading: (div, height = "250px")->
    if $(".g-spinner", div).length is 0
      div.empty()
      spinner = new SharedSpinnerView()
      hash =
        container: div
        id: "g-spinner"
        height: height
      spinner.show(hash)

  openLinksInNewTab: (div_links) ->
    div_links.attr("target","_blank")

  replaceNewLineWithBreak: (text) ->
    text?.replace(/\n|\\x0a/gi, '<br />')

  renderFinePrint: ->
    finePrintView = new SupportFinePrintView()
    finePrintView.render()

  textOverflowEllipsis: (length) ->
    ->
      (text, render) ->
        content = render text
        content = content.trim()
        if content.length > length
          delimitedContent = content.substring(0, length - 3) + '...'
          return '<span title="' + content + '">' + delimitedContent + '</span>'
        else
          return content

  addToTrackingHub: (c, sc) ->
    data =
      category: c,
      subcategory: sc
    TrackingHub.add("support-app-user-dropdown-change", {data: data})

  activateieHacks: ->
    ieISODateStringHack()
    ieStringTrimHack()

  ieISODateStringHack: ->
    # Override only if native toISOString is not defined
    unless Date::toISOString

      # Here we rely on JSON serialization for dates because it matches
      # the ISO standard. However, we check if JSON serializer is present
      # on a page and define our own .toJSON method only if necessary
      unless Date::toJSON
        Date::toJSON = (key) ->
          f = (n) ->

          # Format integers to have at least two digits.
          (if n < 10 then "0" + n else n)
          @getUTCFullYear() + "-" + f(@getUTCMonth() + 1) + "-" + f(@getUTCDate()) + "T" +
          f(@getUTCHours()) + ":" + f(@getUTCMinutes()) + ":" + f(@getUTCSeconds()) + "Z"

      Date::toISOString = Date::toJSON

  ieStringTrimHack: ->
    if typeof String.prototype.trim != 'function'
      String.prototype.trim = ->
        @replace /^\s+|\s+$/g, ''

  isUserLogged: ->
    if currentUser? then true else false

  match: (arg1, arg2) ->
    split1 = arg1?.split(";")
    split2 = arg2?.split(";")
    diff = _.difference split1, split2
    diff.length == 0

  addParameterToUrlConsideringTheHash: (url, parameterName, parameterValue, atStart) -> #Add param before others
    replaceDuplicates = true
    if url.indexOf("#") > 0
      cl = url.indexOf("#")
      urlhash = url.substring(url.indexOf("#"), url.length)
    else
      urlhash = ""
      cl = url.length
    sourceUrl = url.substring(0, cl)
    urlParts = sourceUrl.split("?")
    newQueryString = ""
    if urlParts.length > 1
      parameters = urlParts[1].split("&")
      i = 0

      while (i < parameters.length)
        parameterParts = parameters[i].split("=")
        unless replaceDuplicates and parameterParts[0] is parameterName
          if newQueryString is ""
            newQueryString = "?"
          else
            newQueryString += "&"
          newQueryString += parameterParts[0] + "=" + ((if parameterParts[1] then parameterParts[1] else ""))
        i++
    newQueryString = "?"  if newQueryString is ""
    if atStart
      newQueryString = "?" + parameterName + "=" + parameterValue + ((if newQueryString.length > 1 then "&" + newQueryString.substring(1) else ""))
    else
      newQueryString += "&"  if newQueryString isnt "" and newQueryString isnt "?"
      newQueryString += parameterName + "=" + ((if parameterValue then parameterValue else ""))
    urlParts[0] + newQueryString + urlhash


  getURLParameter: (name) ->
    decodeURI (RegExp(name + "=" + "(.+?)(&|$)").exec(location.search) or [null, null])[1]

  isCurrentOrderMarketRateDeal: ->
    @isCurrentOrderOfDealType "GETAWAYS_MARKET_RATE"

  isCurrentOrderGetawaysTonightDeal: ->
    @isCurrentOrderOfDealType "GETAWAYS_TONIGHT"

  isCurrentOrderGetawaysBookingDeal: ->
    @isCurrentOrderOfDealType "GETAWAYS_BOOKING"

  isCurrentOrderGoodsDeal: ->
    @isCurrentOrderGoodsShippingDeal() or @isCurrentOrderGoodsVoucherDeal()

  isCurrentOrderGoodsShippingDeal: ->
    @isCurrentOrderOfDealType "GOODS_SHIPPING"

  isCurrentOrderGoodsVoucherDeal: ->
    @isCurrentOrderOfDealType "GOODS_VOUCHER"

  isCurrentOrderLiveDeal: ->
    @isCurrentOrderOfDealType "LIVE"

  isCurrentOrderLocalDeal: ->
    @isCurrentOrderOfDealType "LOCAL"

  isCurrentOrderOfDealType: (deal_type)->
    Groupon.Support.currentOrder?.DEAL_TYPE is deal_type

  isCurrentOrderEditable: ->
    Groupon.Support.currentOrder?.editable is true

  isOrderPurchasedWithinHours: (specifiedHours) ->
    Groupon.Support.currentOrder?.hoursAfterPurchase < specifiedHours

  isCurrentOrderGetawaysDeal: ->
    isCurrentOrderMarketRateDeal() or isCurrentOrderGetawaysTonightDeal() or isCurrentOrderGetawaysBookingDeal()

  checkIfCategoryIsAboutEditingOrCancelling: ->
    checkIfCategoryIdMatches "editing_or_canceling_an_order"

  checkIfCategoryIdMatches: (categoryId) ->
    Groupon.Support.ContentModel.getCategory()?.id is categoryId

  getCurrentUserFullName: ->
    if currentUser?
      "#{$.trim(currentUser.firstName)} #{$.trim(currentUser.lastName)}".trim()

  setTrackingInformation : ( type , url ) ->
    TrackingHub.page.metadata.type = type
    OptimizeSuite.treatAsNewPage url

  getMillisecondsOfUTCDateFromISOStringDate: (ISOStringDate) ->
    base = 10
    # gets the given date in UTC milliseconds
    Date.UTC(parseInt(ISOStringDate.substring(0,4),base), parseInt(ISOStringDate.substring(5,7), base) - 1,parseInt(ISOStringDate.substring(8,10), base),parseInt(ISOStringDate.substring(11,13), base),parseInt(ISOStringDate.substring(14,16), base))

  redirectToFaqHack: () ->
    hash = window.location.hash
    if hash.indexOf("#faqs:") > -1
      window.location.assign "/faq#{hash}"

  hideFloatingBoldChat: ->
    floatingChatElement = $('.bcFloat')
    if floatingChatElement?.length > 0
      floatingChatElement.hide()
      floatingChatElement.children().hide()

  showFloatingBoldChat: ->
    floatingChatElement = $('.bcFloat')
    if floatingChatElement?.length > 0
      floatingChatElement.show()
      floatingChatElement.children().show()

  getDealMerchantName: ->
    if isCurrentOrderMarketRateDeal() or isCurrentOrderGetawaysTonightDeal() or
    (isCurrentOrderGetawaysBookingDeal() and isIntl())
      reservationSource = @getReservationSource(Groupon.Support.currentOrder)
      reservationSource?.hotelName
    else
      Groupon.Support.currentOrder?.merchant?.name

  isStaticLiveChat: (mode) ->
    mode is 'static'

  isBothLiveChats: (mode) ->
    mode is 'both'

  isFloatingLiveChat: (mode) ->
    mode is 'floating'

  getOrderInfoForBH: (order) ->
    hash =
      id: order?.id
      country: window.country.name
      dealId: order?.deal?.id
      channel: order?.DEAL_TYPE
    if window.showRedesign()
      hash.showActionButtonAsLinks = true
    hash

  showRedesign: () ->
    Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled() || window.evaluate(window.experiments?.showVerticalPageFlow)

  priorityViewsEnabled:()->
    Groupon.Support.ContentModel?.isRefundEligible or Groupon.Support.ContentModel?.escalateToMerchant

  liveChatVisible:(liveChatDOMElem)->
    clearImgurl = /images.boldchat.com\/images\/clear/
    liveChatDOMElem? and not(_.isEmpty(liveChatDOMElem.attr 'src' )) and not clearImgurl.test liveChatDOMElem.attr('src')

  setLiveChatDisplayCallBack: (liveChatDOMElem, liveChatDisplayCallback)->
    if liveChatDOMElem?[0]? and not window.liveChatCallBackSet
      window.liveChatCallBackSet = true
      liveChatDOMElem.on('load', -> liveChatDisplayCallback())
    else if not liveChatDOMElem?[0]?
      window.liveChatCallBackSet = false

  liveChatLinkVisible: ->
    liveChatImageElem = $("#live-chat-link-container div a div")
    not _.isEmpty liveChatImageElem.text()

  getReservationSource: (currentOrder) ->
    currentOrder?.reservation || currentOrder?.travelBookingInfo?.reservation

  findGrouponQuantity: (groupons) ->
    quantity = 0
    if groupons?
      _.each(groupons, (groupon)->
        if groupon.availability
          if groupon.availability.toLowerCase() isnt 'refunded'
            quantity++
      )
    return quantity

  shouldShowOptimizedChannel: () ->
    evaluate(experiments?.showOptimizedContactChannel) and not window.priorityViewsEnabled()

  shouldShowFlexibleChannel: () ->
    evaluate(experiments?.showFlexibleContactChannels) and not window.priorityViewsEnabled()

  hideFooterLinks: () ->
    window.hideDOMElems $("#footer_dynamic_links")

  showFooterLinks: () ->
    window.showDOMElems $("#footer_dynamic_links")

module.exports = SupportUtilsHelper
